<template>
    <div v-redirect-if-no-permission:CASH_REGISTER_MASTER>
        <loading-component v-model="loading"></loading-component>
        <DataTable url="cash_registers_events/pending_transactions" :enable-add="false"
                   :enable-delete="false" :enable-edit="false" :actions-extra-main="actions"
                   title="Cash Register Pending Transactions" :key="cnt"></DataTable>
    </div>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import moment from "moment";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "PendingTransactions",
        components: {LoadingComponent, DataTable},
        data() {
            return {
                loading: false,
                cnt: 0
            }
        },
        computed: {
            actions() {
                return {
                    approve: {
                        title: "Approve",
                        color: 'primary',
                        action: async (item) => {
                            this.loading = true;
                            this.axios.put(`cash_registers_events/${item.id}/approve`)
                                .then(() => {
                                    window.getApp.$emit("SHOW_TOAST", "Approved", "green")
                                    this.cnt++
                                })
                                .catch(err => {
                                    try {
                                        if (err.response.data.message) {
                                            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                                        } else {
                                            window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                                        }
                                    } catch (e) {
                                        console.log(err.message, e.message);
                                    }
                                }).finally(() => this.loading = false);
                        }
                    },
                    reject: {
                        title: "Reject",
                        color: 'red',
                        action: async (item) => {
                            this.loading = true;
                            this.axios.put(`cash_registers_events/${item.id}/reject`)
                                .then(() => {
                                    window.getApp.$emit("SHOW_TOAST", "Approved", "green")
                                    this.cnt++
                                })
                                .catch(err => {
                                    try {
                                        if (err.response.data.message) {
                                            window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red", ['center', 'top']);
                                        } else {
                                            window.getApp.$emit("SHOW_TOAST", err.message, "red", ['center', 'top']);
                                        }
                                    } catch (e) {
                                        console.log(err.message, e.message);
                                    }
                                }).finally(() => this.loading = false);
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>